function convertLabel(configs, label) {
	try {
		let { label_language_mappings, selectedLanguage } = configs;
		if (
			label_language_mappings &&
			label_language_mappings[label] &&
			selectedLanguage === "fr"
		) {
			return label_language_mappings[label];
		}
	} catch (e) {}
	return label;
}

export { convertLabel };
